export const en = {
    common: {
        PIN_CODE_LABEL: 'PIN Code',
        USER_NAME_LABEL: 'Full name',
        comment: 'Comment',
        year: 'Year',
        configuration: 'Configuration',
        cancel: 'Cancel',
        search: 'Search',
        remove: 'Remove',
        confirmationDialogTitle: 'Are you sure to remove this item?',
        selectDate: 'Select date',
        select: 'Select',
        notFound: 'Not found',
        equipmentPickerPlaceholder: 'Equipment object...',
        searchPlaceholder: 'Search...',
        equipmentTypePickerPlaceholder: 'Equipment type...',
        equipmentTypePickerTitle: 'Select equipment type',
        emptyTableMessage: 'No data',
        flowPikcerTitle: 'Select flow',
        selectIcon: 'Select icon',
        locationPickerTitle: 'Select location',
        locationPlaceholder: 'Location...',
        noSublocations: 'No sublocations',
        locationsTitle: 'Locations',
        edit: 'Edit',
        save: 'Save',
        added: 'Added',
        updated: 'Updated',
        add: 'Add',
        removed: 'Removed',
        reload: 'Reload',
        confirm: 'Confirm',
        rollBack: 'Roll back',
        images: 'Images',
        documents: 'Documents',
        download: 'Download',
        saved: 'Saved',
        date: 'Date',
        hour: 'Hour',
        preview: 'Preview',
        data: 'Data',
        attributes: 'Attributes',
        checkList: 'Checklist',
        name: 'Name',
        type: 'Type',
        status: 'Status',
        designation: 'Designation',
        symbol: 'Symbol',
        serialNumber: 'Serial number',
        registryNumber: 'Registry number',
        machineNumber: 'Machine number',
        udtNumber: 'UDT number',
        manufacturedYear: 'Manufactured year',
        manufacturer: 'Manufacturer',
        supplier: 'Supplier',
        mainSupplier: 'Main supplier',
        attribute: 'Attribute',
        nameRequired: 'Name is required',
        yearGreaterThan: 'Year must be greater than',
        location: 'Location',
        fieldRequired: 'This field is required',
        description: 'Description',
        minimumQuantity: 'Minimum quantity',
        optimalQuantity: 'Optimal quantity',
        priority: 'Priority',
        formatYYYY: 'Format YYYY',
        storageQuantity: 'Warehouse quantity',
        quantity: 'Quantity',
        quantityGreaterThan: 'Quantity must be greater than',
        machine: 'Machine',
        tool: 'Tool',
        order: 'Order',
        required: 'Required',
        dateFormat: 'Date format',
        selectDictionary: 'Select dictionary',
        selectDictionaryValue: 'Select dictionary value',
        return: 'Return',
        parameters: 'Parameters',
        editCategory: 'Edit category',
        addCategory: 'Add new category',
        changeColor: 'Change color',
        noColor: 'No color',
        shift: 'Shift',
        start: 'Start',
        end: 'End',
        shiftSchema: 'Schift schema',
        shifts: 'Shifts',
        dictionary: 'Dictionary',
        subEntries: 'Subentries',
        key: 'Key',
        value: 'Value',
        moveUp: 'Move up',
        moveDown: 'Move down',
        addLocation: 'Add new location',
        editLocation: 'Edit location',
        companiesDatabase: 'Companies database',
        flows: 'Flows',
        read: 'Read',
        write: 'Write',
        noImage: 'No image',
        email: 'E-mail',
        function: 'Function',
        active: 'Active',
        notActive: 'Not activated',
        disabled: 'Disabled',
        entryNumber: 'Entry number',
        issuedDate: 'Issued date',
        expiresDate: 'Expires date',
        move: 'Move',
        separateForm: 'Separate from',
        separate: 'Separate',
        warehouse: 'Warehouse',
        actions: 'Actions',
        putInCurrentLocation: 'Put in current location',
        selectLocationFormRightMenu: 'Select location from right-side menu',
        showUnassignedItems: 'Show unassigned items',
        separated: 'Separated',
        moved: 'Moved',
        categories: 'Categories',
        welcome: 'Welcome',
        loginToSignaloCMMS: 'Log in to Signalo CMMS',
        login: 'Log in',
        loginByEmailAndPassword: 'Log in by email and password',
        loginByCode: 'Log in by code',
        accessCode: 'Access code',
        enterEmail: 'Enter email',
        enterPassword: 'Enter password',
        enterCode: 'Enter code',
        userNotFound: 'User not found',
        userNotActivated: 'User not activated',
        userDisabled: 'User disabled',
        wrongPassword: 'Wrong password',
        locations: 'Locations',
        pageNotFound: 'Page not found',
        group: 'Group',
        yes: 'Yes',
        no: 'No',
        hourlyCost: 'Hourly cost',
        price: 'Price',
        newEntry: 'New entry',
        predictedFinishTime: 'Predicted finish time',
        ok: 'Ok',
        archive: 'Archive',
        costs: 'Costs',
        companyManagement: 'Company management',
        companyData: 'Company data',
        supportedLanguages: 'Supported languages',
        en: 'English',
        pl: 'Polish',
        es: 'Spanish',
        de: 'German',
        it: 'Italian',
        fr: 'French',
        ru: 'Russian',
        uk: 'Ukrainian',
        pt: 'Portuguese',
        tr: 'Turkish',
        nl: 'Dutch',
        sr: 'Serbian',
        defaultLanguage: 'Default language',
        companyLogo: 'Company logo',
        notificationsManagement: 'Notifications management',
        category: 'Category',
        today: 'Today',
        month: 'Month',
        week: 'Week',
        day: 'Day',
        close: 'Close',
        show: 'Show',
        rollBackFormalConfirmation: 'Rollback formal confirmation',
        signUp: 'Sign up',
        nameSurname: '@:common.USER_NAME_LABEL',
        users_name_label: 'Full name label',
        userNameSurname: 'Full name',
        userSurnameName: 'Surname and name',
        phone: 'Phone number',
        password: 'Password',
        password_confirmation: 'Confirm password',
        unassignedItems: 'Unassigned items',
        currency: 'Currency',
        general: 'General',
        timezone: 'Timezone',
        users: 'Users',
        groups: 'Groups',
        productionLine: 'Production line',
        part: 'Part',
        fittingParts: 'Fitting parts',
        workSchema: 'Work schema',
        workSchemas: 'Work schemas',
        holiday: 'Holiday',
        changePassword: 'Change password',
        showRest: 'Show rest',
        pageNotPermitted: 'Page not permitted',
        waitingForActivation: 'Waiting for activation',
        editGroup: 'Edit group',
        addGroup: 'Add group',
        reportProblem: 'Report problem',
        describeOccuredIssue: 'Describe occured issue',
        markAllAsRead: 'Mark all as read',
        unitType: 'Unit type',
        unit: 'Unit',
        unitPrice: 'Unit price',
        notConfigured: 'Not configured',
        rowsPerPage: 'Rows per page',
        rowsOfPage: 'of',
        true: 'True',
        false: 'False',
        export: 'Export',
        chooseFileFormat: 'Choose file format',
        exported: 'Exported',
        terminals: 'Terminals',
        terminal: 'Terminal',
        selectEquipment: 'Select equipment',
        futureIssues: 'Future issues',
        scheduledOn: 'Scheduled on',
        planned: 'Planned',
        notPlanned: 'Unplanned',
        showOpenIssues: 'Show open issues',
        pin: 'PIN',
        assignedEquipment: 'Assigned equipment',
        terminalEquipment: 'Terminal equipment',
        detach: 'Detach',
        attach: 'Attach',
        dashboardConfig: 'Dashboard config',
        addColumn: 'Add column',
        addRow: 'Add row',
        removeRow: 'Remove row',
        registerTerminal: 'Register terminal',
        issueGeneratesCost: 'Downtime generates cost',
        selectColor: 'Select color',
        belowMinimum: 'Below minumum',
        belowOptimum: 'Below optimum',
        synchronization: 'Synchronization',
        synchronizationExport: 'Export of stock parts',
        synchronizationImport: 'Import of stock parts',
        mapping: 'Mapping',
        returnTo: 'Return to',
        jobStatusses: 'Processes',
        hidden: 'Hidden',
        editEvent: 'Edit event',
        threeDays: '3 days',
        addEvent: 'Add event',
        plannedIssues: 'Planned issues',
        currentService: 'Current service',
        searchLocation: 'Find location',
        all: 'All',
        unfinished: 'Unfinished',
        numberOfIssues: 'Issues quantity',
        unknown: 'Unknown',
        partEntry: 'Part (entry)',
        foundItems: 'Found items',
        output: 'Output',
        copied: 'Copied',
        link: 'Link',
        authorizationRequired: 'Authorization required',
        authorizationRequiredDescriptionUser:
            'Unfortunately, you do not have sufficient authorization {value}. Ask an authorized person to approve the action.',
        authorizationRequiredDescriptionTerminal:
            'Use your access code to authorize action.',
        showAll: 'Show all',
        showClassicView: 'Classic view',
        noIssuesInCategory: 'No issues in this category.',
        numberOfIssuesInThisCategoryAndSubcategories:
            'Number of issues in this category and subcategories.',
        numberOfIssuesInThisCategory: 'Number of issues in this category.',
        minBarcodeLength: 'Minimum barcode length',
        currentPage: 'Current page',
        allPages: 'All pages',
        selectFormat: 'Select format',
        provided_currency: 'Provided currency',
        provided_quantity: 'Provided quantity',
        provided_unit: 'Provided unit',
        provided_unit_price: 'Provided unit price',
        unit_price: 'Unit price',
        quantity_available: 'Quantity available',
        editBarcode: 'Edit barcode',
        crews: 'Crews',
        scheduleEventTypes: 'Schedule events types',
        crew: 'Crew',
        scheduleEvent: 'Schedule event',
        available: 'Available',
        'App\\Models\\Crew': 'Crew',
        'App\\Models\\User': 'User',
        'App\\Models\\Equipment': 'Equipment',
        'App\\Models\\Part': 'Part',
        Crew: 'Crew',
        User: 'User',
        Equipment: 'Equipment',
        Part: 'Part',
        scheduleEvents: 'Schedule events',
        event: 'Event',
        externalSystems: 'External systems',
        user: 'User',
        availability: 'Availability',
        inheritColorFromParentIfCustomNotSet:
            'Inherit color from parent if custom not set',
        pickFromAllParts: 'Pick from all parts',
        takeTool: 'Take tool',
        returnTool: 'Return tool',
        personWhoTake: 'Person who take',
        personWhoReturn: 'Person who return',
        takenAt: 'Taken at',
        takenBy: 'Taken by',
        toolIssuedBy: 'Tool issued by',
        commentTake: 'Take comment',
        commentReturn: 'Return comment',
        change: 'Change',
        onlyWithActiveRMIssues: 'Only with active RM issues',
        externalSystem: 'External system',
        rejectIssue: 'Reject issue',
        withdrawIssueRejection: 'Withdraw issue rejection',
        rejectionReason: 'Reason of rejection',
        rejected: 'Rejected',
        showCrewMembers: 'Show crew members',
        crewMembers: 'Crew members',
        helpGroup: 'Service',
        partsTakenByUser: 'Parts taken by user',
        pickParts: 'Issue parts',
        selectPersonWhoTakes: 'Select person who takes',
        changePersonWhoTakes: 'Change person who takes',
        quantityToPick: 'Quantity to pick',
        pickLocation: 'Pick-up location',
        selectPartsToPick: 'Select parts to pick',
        partSelected: 'Part selected',
        scanCodeOr: 'Scan code or',
        returnPart: 'Return part',
        myTakenParts: 'Parts taken by me',
        takenFromLocation: 'Taken from location',
        takenQuantity: 'Taken quantity',
        providedUnit: 'Provided unit',
        providedQuantity: 'Provided quantity',
        selectFromStorage: 'Select from storage',
        selectFromMyPickedParts: 'Select from my picked parts',
        exportProcessInProgressMessage:
            'The data export process has just started, when it is completed you will see a corresponding notification containing a link to the file.',
        yourDocumentIsReady: 'Your document is ready',
        rotateScreen: 'Rotate screen',
        addRule: 'Add rule',
        editRule: 'Edit rule',
        summary: 'Summary',
        onlyAvailableEmployees: 'Only available employees',
        calculated_unit_price: 'Calculated unit price',
        calculated_quantity: 'Calculated quantity',
        next: 'Next',
        maintenanceMode: 'Maintenance mode',
        applicationMayBeUnavailableForFewMinutes:
            'Application may be unavailable for few minutes',
        appWillRefreshIn: 'Application will reload in',
        landscape: 'Landscape',
        portrait: 'Portrait',
        orientation: 'Orientation',
        format: 'Format',
        service: 'Service',
        leader: 'Leaders',
        defaultView: 'Default view',
        view: 'View',
        oneDay: '1 day',
        object: 'Object',
        finished: 'Finished',
        onlyNotFinished: 'Only not finished',
        generate: 'Generate',
        error: 'Error',
        cell: 'Cell',
        resolutionSummary: 'End Summary',
        rejected_at: 'Rejection date',
        rejected_by: 'Rejected by',
        finishedByUser: 'Finished by',
        formalConfirmByUser: 'Formal confirm by',
        formalConfirmAt: 'Formal confirm date',
        valueDeleted: '[Value deleted]',
        hasNotPlannedIssue: 'Has not planned issues',
        showInStorage: 'Show in storage',
        changeCode: 'Change code',
        staffProfiles: 'Staff profiles',
        profile: 'Profile',
        user_bug: 'Application Bug',
        user_kaizen: 'Change suggestion',
        changeSuggestions: 'Change suggestions',
        showOnlyCurrentlyAvailable: 'Show only currently available',
        resetPassword: 'Reset password',
        forgotPassword: 'Forgot password',
        resetPasswordMailSent:
            'We have sent a link to set a new password to the provided e-mail',
        manyEventsThisTime: 'Many events at this time',
        importScheduleCheckboxLabel:
            'Delete scheduled events in the selected month for employees listed in the file',
        inheritedEvent: 'Inherited event',
        inheritedModifiedEvent: 'Modified inherited event',
        equipmentId: 'Equipment ID',
        entryId: 'Entry ID',
        partId: 'Part ID',
        suggestionsEmail: 'E-mail to which change suggestions will be sent',
        meters: 'Meters',
        scanCardToAuth:
            'Scan card or enter your access code to confirm your identity',
        scanCard: 'Scan card',
        cart: 'Drop box',
        emptyCardMessage:
            'Start scanning products or select them from the list to add them to the drop box.',
        terminalMode: 'Terminal type',
        askPermittedUserToConfirmPartsExchange:
            'Ask the authorized person to confirm the release / return of the part by scanning the card or entering the code',
        partsIssued: 'Parts issued',
        areYouSureAboutCancel: 'Are you sure you want to cancel?',
        areYouSureAboutRemoveFromCart:
            'Are you sure you want to remove this item from the drop box?',
        standard: 'Standard',
        idNumber: 'Identification number',
        takeParts: 'Take parts',
        returnParts: 'Return parts',
        quantityToReturn: 'Quantity to return',
        partsPendingApproval: 'Parts pending approval',
        partsReturned: 'Parts returned',
        partsAddedToPendingApproval: 'Parts added to pending approval',
        approvePartsReturn: 'Approve parts return',
        partReturnApproved: 'Part return approved',
        partUsage: 'Part usage',
        awaitsReturn: 'Awaits return',
        entrySelection: 'Entry selection',
        correctQuantity: 'Correct quantity',
        quantityCorrection: 'Quantity correction',
        entrySelectionAsc: 'Entry selection (ascending)',
        entrySelectionDesc: 'Entry selection (descending)',
        metersSettings: 'Meters settings',
        countableFields: 'Countable fields',
        equipmentTypes: 'Equipment types',
        fieldName: 'Field name',
        countableField: 'Countable field',
        partsStatusTaken: 'Taken',
        rejectPartsReturn: 'Reject parts return',
        areYouSureAboutRejectPartsReturn:
            'Are you sure you want to reject parts return?',
        partReturnRejected: 'Part return rejected',
        counterFields: 'Counter fields',
        counterName: 'Counter name',
        counterFieldName: 'Counter field name',
        counterId: 'Counter ID',
        counterUUID: 'Counter UUID',
        counterPickerPlaceholder: 'Select counter',
        pickFromPartsList: 'Pick from parts list',
        changeLocation: 'Change location',
        isPartStorageRoot: 'Part storage root',
        isStorageRoot: 'Part storage root',
        areYouSureAboutArchiveIssue:
            'Are you sure you want to archive this issue?',
        ganttChart: 'Gantt chart',
        table: 'Table',
        fittingEquipment: 'Fitting equipment',
        notAssigned: 'Not assigned',
        counters: 'Counters',
        machineHourlyCostNotProvided: 'The machine has no hourly cost set',
        eventTypesMightBeDefinedHere: 'Event types might be defined here',
        toolsTakenByUser: 'Tools taken by user',
        predictedReturnDate: 'Predicted return date',
        estimatedTimeOfUsingToolInHours:
            'Estimated time of using tool (in hours)',
        showOnlyAvailable: 'Show only available',
        toolTakeLog: 'Log of takes and returns',
        takeDate: 'Take date',
        returnDate: 'Return date',
        personWhoAcceptReturn: 'Person who accept return',
        statisticStrategy: 'Accessibility strategy',
        EquipmentPlannedStrategy: 'According to work plan',
        EquipmentConstantAvailabilityStrategy: 'Constant availability',
        actionAfterIssueFinish: 'Action after issue finish',
        enabled: 'Enabled',
        categoryOfNewIssue: 'Category of new issue',
        workNotStarted: 'Work not started',
        colorInherited: 'Color inherited',
        abcClassification: 'ABC classification',
        xyzClassification: 'XYZ classification',
        classification: 'Classification',
        filters: 'Filters',
        wipeFilters: 'Wipe filters',
        takePartsFromUser: 'Take parts from user',
        selectPersonWhoReturns: 'Select person who returns parts',
        changePersonWhoReturns: 'Change person who returns parts',
        returnLocation: 'Return location',
        returnQuantity: 'Return quantity',
        globalSettings: 'Global Settings',
        delimiter: 'Delimiter',
        fieldRules: 'Field rules',
        fieldValue: 'Field value',
        user_email_regex: 'User e-mail regex',
        barcodeLength: 'Barcode length',
        partLine: 'Part line',
        partFamily: 'Part family',
        partBatch: 'Part batch',
        testValueValid: 'Test value valid',
        testValueNotValid: 'Test value not valid',
        canBePicked: 'Can be chosen',
        create_issue_criticality: 'Create issue - criticality',
        issue_criticality: 'Issues - criticality',
        issue_help_webapp: 'Issues  - support needed (App)',
        issue_help_terminal: 'Issues - support needed (Terminal)',
        issue_kind: 'Report kind',
        HIDE: 'Hide',
        SHOW: 'Show',
        REQUIRE: 'Require',
        propagateValues: 'Propagate values',
        archived: 'Archived',
        singleEvent: 'Single entry',
        seriesOfEvents: 'A series of entries',
        omitWeekends: 'Omit weekends',
        allEntriesSaved: 'All entries have been added',
        parentCategory: 'Parent category',
        first_day_of_week: 'First day of week',
        assignEmployee: 'Przypisz pracownika',
        addNewMachine: 'Add a new machine',
        addNewTool: 'Add a new tool',
        parentLocation: 'Parent location',
        equipmentStates: 'Equipment states',
        equipmentState: 'Equipment state',
        fontColor: 'Font color',
        downtime: 'Downtime',
        setState: 'Set state',
        from: 'From',
        to: 'To',
        inProgress: 'In progress',
        noEntries: 'No entries',
        products: 'Products',
        product: 'Product',
        setCurrentProduct: 'Set the product currently in production',
        commentable: 'Comment available',
        allows_state_update: 'State change required during comment',
        undescribed: 'Indescribable',
        state: 'Condition',
        productionMonitor: 'Production monitor',
        undescribedStates: 'Undescribed states',
        toolsPicker: 'Take / return tools',
        toolsGroups: 'Tool groups',
        of: 'of',
        image: 'Image',
        selectTools: 'Select tools',
        takeTools: 'Take tools',
        returnTools: 'Return tools',
        askPermittedUserToConfirmToolsExchange:
            'Ask the authorized person to confirm the issuance/return of the tools by scanning the card or entering the code.',
        toolsPendingApproval: 'Returned tools awaiting approval',
        production_monitor_visible_columns:
            'Production monitor - visible columns',
        details: 'Details',
        otherData: 'Other data',
        showAllTools: 'Show all tools',
        allTools: 'All tools',
        approveToolReturn: 'Approve return of the tool',
        rejectToolReturn: 'Reject return ot the tool',
        areYouSureAboutRejectToolReturn:
            'Are you sure you want to reject the return of the tool?',
        areYouSureAboutAcceptToolReturn:
            'Are you sure you want to confirm the return of the tool?',
        toolReturnApproved: 'Tool return approved',
        toolReturnRejected: 'Tool return rejected',
        toReturn: 'To return',
        toolsCart: 'Cart - tools',
        toolsIssued: 'Tools issued',
        toolsAddedToPendingApproval:
            'The tools have been added to the return approval waiting list',
        toolsReturned: 'Tools returned',
        mainShift: 'Main shift',
        scanCode: 'Scan the code',
        codeRecognized: 'Code recognized',
        moveAllEntriesFromCurrentLocation:
            'Move all entries from this location',
        newAwaitingValue: 'New value awaiting approval',
        newValuesArePendingConfirmation: 'The changes are awaiting approval',
        changeRequests: 'Change requests',
        currentValues: 'Current values',
        requestedValues: 'Values to change',
        removeRequestIsWaitingForApprove: 'The deletion is pending approval',
        imageRemoveRequestLabel: 'Deleting a photo',
        areYouSureAboutCancelChangeRequest:
            'Are you sure you want to cancel the change request?',
        document: 'Document',
        rename: 'Rename',
        openInEditor: 'Open in editor',
        unsavedChangesMayBeLost: 'Unsaved changes may be lost',
        location_name_regex: 'Location name rule',
        employeesWorkingCount: 'Number of employees working on this issue',
        always: 'Always',
        indexes: 'Indexes',
        indexesEntriesTypes: 'Indexes entries types',
        indexEntry: 'Index entry',
        index: 'Index',
        pickIndex: 'Pick index',
        report: 'Report',
        reportGenerationInProgress: 'The report is generating',
        production_monitor_equipment_state_change:
            'Changing the machine status from the production monitor',
        part_entries_auto_barcode_generation:
            'Automatic barcode generation for part entries',
        new_issue_equipment_kind: 'Type of equipment in the new application',
        manageVisibleColumns: 'Adjust column visibility',
        columnName: 'Column name',
        visible: 'Visible',
        partStorageRootWarningMessage:
            'This location will be set as the main parts warehouse location, the warehouse and the location selection window will only allow you to select entries located in this location',
        entriesLocation: 'Entries location',
        cloneIssue: 'Clone',
        machinesMap: 'Machine map',
        doYouWantToAddNewMarker: 'Would you like to add a new marker here?',
        areYouSureAboutRemoveMarker:
            'Are you sure you want to remove this marker?',
        plants: 'Factory plants',
        plant: 'Factory',
        buildings: 'Buildings',
        building: 'Building',
        floors: 'Floors',
        floor: 'Floor',
        map: 'Map',
        areYouSureAboutMoveMarker: 'Are you sure you want to move this marker?',
        marker: 'Marker',
        addNewMarkerTooltipMessage:
            'To add a new marker, right-click on the map.',
        takenTools: 'Taken tools',
        askPermittedUserToConfirmToolExchange:
            'Ask the authorized person to confirm the issuance/return of the tool by scanning the card or entering the code.',
        warnDays: 'Alert before expiration (days)',
        licenseType: 'License type',
        licenseGroup: 'License group',
        toolsCartTerminalRequireApproveOnToolReturn:
            'Require confirmation / rejection upon return of taken tools',
        attachments: 'Attachments',
        attachment: 'Attachment',
        searchInCurrentLocation: 'Search in current location',
        icon: 'Icon',
        nfc: 'NFC',
        rfid: 'RFID',
        other: 'Other',
        tags: 'Cards / Tags',
        tag: 'Card / Tag',
        userPinCode: 'Card user pin',
        pin_code_field_type: 'Pin code type',
        alphanumeric: 'Alphanumeric',
        numeric: 'Numerical',
        showCodeOwnerNameDuringParing:
            'Show code owner name when pairing with card/tag',
        showUsernameInCart: 'Show username in cart',
        flag: 'Flag',
        flags: 'Flags',
        manageFlags: 'Manage flags',
        skills: 'Skills',
        skill: 'Skill',
        skillRank: 'Rating',
        selectToolsByType: 'Select tools by type',
        openToolsPickerOnCartInit:
            'Automatically open the tool selection window when you go to the cart.',
        toolsTypes: 'Tool types',
        workOrderTemplates: 'Work order templates',
        workOrderTemplate: 'Work order template',
        workOrders: 'Work orders',
        workOrder: 'Work order',
        employee: 'Employee',
        workOrderCreatedBy: 'Commissioned by',
        print: 'Print',
        issueCreated: 'A ticket has been created',
        newIssue: 'New report',
        sampleButtonPlaceholder: 'Sample button',
        preferences: 'Preferences',
        buttonsSize: 'Buttons size',
        defaultValue: 'Default value',
        warning: 'Warning',
        allowedIssuesCategories: 'Allowed issues categories',
        hideAbilityToAssignEmployeesToIssue:
            'Hide the ability to assign employees to an issue',
        issuesWithRelatedCategories: 'Include subcategories',
        issuesLimit: 'Limit of issues',
        issuesLimits: 'Issues - limits',
        closeLocker: 'Close the locker',
        closeLockerMessage: 'To continue, close the locker',
        closedTooFast: 'Did you close too quickly?',
        doYouWantToReopenLocker: 'Do you want to reopen the locker?',
        reopen: 'Reopen',
        quit: 'Finish',
        hiddenFields: 'Hidden fields',
        defaultValues: 'Default values',
        paddingBottom: 'Empty space from bottom',
        allVisibleFieldsRequired: 'Require all visible fields to be completed',
        emailConfirmation: 'Email address confirmation',
        user_active_after_email_confirm:
            'User account automatically activated after confirming your email address',
        phone_change_requires_confirmation_code:
            'Changing the phone number requires confirmation with a code',
        toolsLocation: 'Tool location',
        manageFilters: 'Manage filters',
        erase: 'Erase',
        can_pick_undescribed_equipment_state:
            'Possibility to choose an undescribed state',
        helpdesk: 'Helpdesk',
        measureTypes: 'Types of measurements',
        measureType: 'Measurement type',
        measurable: 'Measurable indicator',
        measurables: 'Measurable indicators',
        measurements: 'Measurements',
        measurement: 'Measurement',
        measuredAt: 'Measurement date',
        employeeNumber: 'Employee number',
        lastLocation: 'Last location',
        readonly: 'Read-only',
        equipment: 'Equipment',
        conditions: 'Conditions',
        permission: 'Permission',
        formula: 'Formula',
        notification: 'Notification',
        transition: 'Transition',
        fillValuesToChangeState: 'Complete the values to change the status.',
        loginTo: 'Log in to',
        appName: 'Signalo CMSS',
        manageState: 'Manage state',
        webMessage: 'Web message',
        terminalId: 'Terminal ID',
        operatorId: 'Operator ID',
        newConversation: 'New thread',
        application: 'App',
        phones: 'Phones',
        message: 'Message',
        channels: 'Channels',
        url: 'URL',
        kind: 'Kind',
        forkfleetConfigId: 'Forkfleet config id',
        create: 'Create',
        terminate: 'Terminate',
        recreateIssue: 'Recreate issue',
        ordinal: 'Ordinal value',
        parameterName: 'Parameter name',
        backgroundColor: 'Background color',
        columns: 'Number of columns',
        colspan: 'Width (columns)',
        fill: 'Fill',
        duplicate: 'Duplicate',
        loginAsThisUser: 'Log in as this user',
        partLot: 'Part lot',
        minBrowserVersion: 'Minimum required browser version',
        currentVersion: 'Current version',
        equipment_planned_completed_percent_target:
            'Percentage target for the implementation of planned inspections',
        autoTranslate: 'Automatic translation',
        auto_translation: 'Automatic translation',
        awaitingAutoTranslation: 'Waiting for automatic translation',
        signaturePinTagConfirmationText1: 'Sign with @:common.PIN_CODE_LABEL',
        signaturePinTagConfirmationText2: 'or scan your card.',
        signedWithPinCode: 'Signed with @:common.PIN_CODE_LABEL',
        signedWithTAG: 'Signed with card / tag',
        trusted_device_code_login_users_limit:
            'Quick Login - Number of Users Displayed',
        display_fields_issue_created_at: 'Display fields - Issue creation',
        docs_sidebar_hidden_by_default: 'Documents – hide sidebar by default',
        issue: 'Issue',
        control: 'Control',
        compatibility: 'Compatibility',
        replacement: 'Replacement',
        backCompatibility: 'Bidirectional compatibility',
    },
    placeholders: {
        part: 'Select part...',
        nameSurname: '@:common.USER_NAME_LABEL',
        phone: 'Phone number...',
        password: 'Password...',
        password_confirmation: 'Confirm password...',
        email: 'E-mail...',
    },
    auth: {
        notYourAccountQuestion: 'Not your account?',
    },
    signup: {
        registered: 'Success!',
        emailConfirmed: 'The email has been confirmed.',
        registered_info: 'Ask your supervisor to activate your account',
        confirmEmailAddress:
            'Your account has been created, click the link in the email to confirm your address.',
        tokenNotFoundError:
            'The email has already been confirmed or the confirmation link is invalid.',
    },
    paramTypes: {
        text: 'Text',
        note: 'Note',
        integer: 'Integer',
        decimal: 'Decimal',
        date: 'Date',
        time: 'Hour',
        datetime: 'Date and hour',
        color: 'Color',
        icon: 'Icon',
        boolean: 'No / Yes',
        signature: 'Signature',
    },
    tableHeaders: {
        id: 'ID',
        name: 'Name',
        path: 'Path to file',
        category: 'Category',
        equipment: 'Equipment',
        criticality: 'Criticality',
        status: 'Status',
        created: 'Created',
        createdBy: 'Created by',
        fp: 'FP',
        type: 'Type',
        designation: 'Designation',
        symbol: 'Symbol',
        serialNumber: 'Serial number',
        registryNumber: 'Registry number',
        udtNumber: 'UDT number',
        manufacturedYear: 'Manufactured year',
        actions: 'Actions',
        title: 'Title',
        data: 'Date',
        archived: 'Archived',
        manufacturerSymbol: 'Manufacturer symbol',
        min: 'Min',
        opt: 'Opt',
        quantity: 'Quantity',
        priority: 'Priority',
        price: 'Price',
        kind: 'Kind',
        description: 'Description',
        default: 'Default',
        warning: 'Warning',
        problem: 'Problem',
        fixing: 'Fixing',
        changeOrder: 'Change order',
        required: 'Required',
        icon: 'Icon',
        color: 'Color',
        subCategories: 'Subcategories',
        barCode: 'Bar code',
        subLocations: 'Sublocations',
        categories: 'Categories',
        image: 'Image',
        nameSurname: '@:common.USER_NAME_LABEL',
        email: 'Email',
        phone: 'Phone number',
        function: 'Function',
        department: 'Department',
        accountStatus: 'Account status',
        shift: 'Shift',
        licenseNumber: 'License number',
        issuedDate: 'Issued date',
        expiresDate: 'Expires date',
        entries: 'Entries',
        entryNumber: 'Entry number',
        buyPrice: 'Buy price',
        currentLocationQuantity: 'Quantity in current location',
        group: 'Group',
        string: 'Text',
        integer: 'Integer',
        toolsGroup: 'Tools group',
        manufacturer: 'Manufacturer',
        shortName: 'Short name',
        locationName: 'Location name',
        subLocationsQuantity: 'Sublocations quantity',
        isWorkingOnIssue: 'Working on issue',
        openIssues: 'Open issues',
        notificationDate: 'Notifications date',
        titleAndDescription: 'Title and description',
        read: 'Read',
        created_at: 'Created',
        received_at: 'Received',
        started_at: 'Took',
        arrived_at: 'Arrived',
        finished_at: 'Finished',
        country: 'Country',
        city: 'City',
        progress: 'Progress',
    },
    searchConfig: {
        id: 'Id',
        name: 'Name...',
        shortName: 'Short name...',
        country: 'Country...',
        email: 'Email...',
        group: 'Group...',
        planned: 'Planned',
        category: 'Category...',
        object: 'Object...',
        criticality: 'Criticality',
        fp: 'FP',
        type: 'Type...',
        designation: 'Designation...',
        symbol: 'Symbol...',
        serialNumber: 'Serial number...',
        registryNumber: 'Registry number...',
        udtNumber: 'UDT number...',
        manufacturedYear: 'Manufactured year...',
        manufacturerSymbol: 'Manufacuter symbol...',
        priority: 'Priority...',
        quantity: 'Quantity...',
        buyPrice: 'Buy price...',
        kind: 'Kind...',
        toolsGroup: 'Tools group...',
        function: 'Function...',
        department: 'Department...',
        status: 'Status...',
        nameSurname: '@:common.USER_NAME_LABEL',
        phone: 'Phone...',
        barCode: 'Bar code',
        color: 'Color...',
        icon: 'Icon...',
        machine: 'Machine...',
        tool: 'Tool...',
        urgentAndOutdated: 'Urgent and outdated',
        urgent: 'Urgent',
        expired: 'Expired',
        manufacturer: 'Manufacturer',
    },
    errors: {
        error: 'An error occured',
        wrongEmail: 'Invalid email',
        wrongPasswordLength: 'Password must be at least 8 characters length.',
        wrongCodeLength: 'Code must be at least 5 characters length.',
        passwordsNotMatch: 'Passwords not match',
        codesNotMatch: 'Codes not match',
        codeAlreadyInUse: 'Code already used',
        expiresDateLowerThanIssued:
            'Expires date cannot be lower than issued date.',
        cannotMoveToTheSameLocation: 'Cannot move to the same location.',
        locationRequired: 'Location is required.',
        putQuantity: 'Put quantity to separate.',
        valueGreaterThanQuantity: 'Value is greater than total quantity.',
        wholeCannotBeDistinguished: 'Whole cannot be distinguished.',
        yearMustBeGreaterThan: 'Year must be greater than ',
        passwordConfirmationNotMatch: 'Passwords not match',
        mustBeInteger: 'Value must be an integer',
        valueTooLong: 'Value too long',
        wrongPhoneNumber: 'Wrong phone number',
        phoneNumberAlreadyTaken: 'Phone number already taken',
        emailAlreadyTaken: 'Email already taken',
        notFound: 'Not found',
        sessionExpired: 'Session expired',
        tenantNotFound:
            'The indicated configuration does not exist. Check the site address and try again.',
        selectEquipmentTypeToConfigureParameters:
            'Select equipment type to configure parameters.',
        noParametersToConfigure:
            'Selected equipment type has no parameters to configure.',
        terminalAlreadyRegistered: 'Terminal already registered.',
        invalidPin: 'Invalid PIN',
        eventCollision:
            'The time of the event you want to add overlaps with the time of another event.',
        mustStartWithSlash: 'Must start with /',
        mustBeBetween: 'Value must be between:',
        minLength: 'Mininum length: ',
        maxLength: 'Maximium length: ',
        invalidInputForCodeType: 'Invalid input for selected code type',
        invalidCodeOrNoPermission:
            'The code is invalid or you do not have sufficient permissions to perform this action.',
        endDateLowerThanStart: 'End date cannot be lower than start date',
        iconAlreadyTaken: 'Icon has already been taken',
        notEnoughQuantityInStorage: 'Insufficient quantity in storage.',
        valueTooLow: 'Value too low',
        valueTooHigh: 'Value too high',
        maxAvailableQuantity: 'Maximum quantity',
        someFilesRejectedDueToSize:
            'Some files were rejected due to size. Max single file size:',
        cameraDeviceNotFound: 'Camera device not found',
        cameraPermissionDenied:
            "Access to the device's camera has been blocked in the site settings, reset the site settings and allow the camera to be used.",
        passwordResetLinkExpired:
            'Der Link zum Zurücksetzen des Passworts ist abgelaufen',
        noInternetConnection: 'No internet connection',
        minimum: 'Minimum',
        mustBeGreaterThan: 'Must be greater than',
        noEventTypesDefined: 'No event types defined',
        regexPatternDelimiterError:
            'An unescaped delimiter must be escaped with \\ character',
        emailNotMatchPatternDefiniedInTenant:
            "Email doesn't match pattern definied in tenant",
        partMustHaveEntriesToCorrectQuantity:
            'The part must have entries to correct the quantity.',
        fileTooBigToOpenWillBeDownloaded:
            'The file is too big to open, the file will be downloaded to your device.',
        entriesNotSavedDueToCollision:
            'Entries have not been added. Events already exist at the selected time.',
        someEntriesWereRejected:
            'Some entries have not been added because they conflict with other events.',
        toolAlreadyInCart: 'This tool is already in your cart',
        toolAlreadyTaken: 'This tool has already been released',
        toolIsNotTaken: 'This tool has not been released',
        documentNotEditable: 'This document cannot be edited',
        notPermissionsToEditDocument:
            'You do not have permission to edit this document',
        cannotLoadDocumentNoPath:
            'The document could not be loaded - invalid address',
        locationNameNotMatchPatternDefiniedInTenant:
            'The name does not match the rule defined in the settings',
        noFloorLayoutProvided: 'The floor has no defined map',
        maximum: 'Maximum value',
        allLanguagesRequired: 'Fill the value in all languages',
        noItemsAvailable: 'No items available',
        noFlagsConfigured: 'No flags defined',
        noSkillsDefined: 'No skill defined',
        someoneIsWorkingOnIssue:
            'Not all employees have completed their work on this report. Are you sure you want to end it?',
        fillAllRequiredParameters: 'Fill values of all required parameters.',
        issueLimitError:
            'The limit of issues in the selected category has been reached: ',
        issueLimitError2: 'and function: ',
        duplicateError: 'This value already exists',
        versionErrorMessage:
            "Your recent changes weren't saved because someone else made changes at the same time. Refresh the page and try again.",
        firstLoginTrustedDeviceError:
            'The first login on a new device requires entering your email address and password.',
        tagNotFound: 'Card/tag not recognized',
        noChecklistsAssignedToControl:
            'The selected control does not have a checklist assigned to it',
        lockerNotConnected: 'Locker is not connected',
        lockerNotAvailable: 'Locker is not available',
        noChecklistItemsError: 'Checklist is not configured',
    },
    navDrawer: {
        dashboard: 'Dashboard',
        issues: 'Issues',
        timetable: 'Timetable',
        machines: 'Machines',
        tools: 'Tools',
        parts: 'Parts',
        storage: 'Warehouse',
        staff: 'Staff',
        configuration: 'Configuration',
        notes: 'Notes',
        notifications: 'Notifications',
        profile: 'Profile',
        supervision: 'Supervision',
    },
    barcodeScanner: {
        barCode: 'Bar code',
        id: 'ID',
    },
    categoryPicker: {
        categoryPlaceholder: 'Cateogory...',
        selectCategory: 'Select category',
        noSubcategories: 'No subcategories',
    },
    companies: {
        addCompany: 'Add company',
        editCompany: 'Edit company',
        fullName: 'Full name',
        shortName: 'Short name',
        group: 'Group',
        country: 'Country',
        city: 'City',
        street: 'Street',
        postCode: 'Post code',
        phone: 'Phone',
        email: 'Email',
        website: 'Website',
        NIP: 'NIP',
        REGON: 'National Business Registry',
        active: 'Active',
        nameRequired: 'Name is required',
        shortNameRequired: 'Name is required',
    },
    issues: {
        tookAt: 'Taken at',
        changeHistory: 'Change history',
        load: 'Load',
        date: 'Date',
        createdBy: 'Created by',
        action: 'Action',
        data: 'Data',
        created: 'Created',
        updated: 'Updated',
        deleted: 'Removed',
        restored: 'Restored',
        issues: 'Issues',
        issue: 'Issue',
        by: 'by',
        name: 'Name',
        applicantsDescription: 'Applicant`s description',
        accidentDescription: 'Accident description',
        jobDescription: "Job's description",
        jobSummary: "Job's summary",
        category: 'Category',
        status: 'Status',
        noFlow: '[No flow]',
        equipment: 'Equipment',
        criticality: 'Criticality',
        hour: 'Hour',
        formalConfirmation: 'Formal confirmation',
        formalConfirmationShortcut: 'FC',
        formalConfirmationRequired: 'FC required',
        parameter: 'Parameter',
        value: 'Value',
        addIssue: 'Add issue',
        expectedCompletionDate: 'Expected completion date',
        issueDescription: 'Issue description',
        partsUsage: 'Disposal of parts',
        assignedEmployees: 'Assigned employees',
        requiredHelp: 'Required help',
        returnParts: 'Return part',
        confirmUnassignEmployeeWhoTakenIssue:
            'This employee has taken selected issue. Do you want to remove him?',
        responsibleUser: 'Responsible user',
        responsibleRules: 'Responsible users - rules',
    },
    machines: {
        machines: 'Machines',
        xIssuesNotPlanned: ' (not planned)',
        noIssues: 'No issues',
    },
    maintenance: {
        maintenance: 'Maintenance',
    },
    notes: {
        notes: 'Notes',
        note: 'Note',
        title: 'Title',
        archived: 'Archived',
    },
    parts: {
        parts: 'Parts',
        warehouseOutgoings: 'Warehouse outgoings',
        fittingEquipmentTypes: 'Fitting equipment types',
        goToEquipmentType: 'Go to equipment type',
        selectPart: 'Select part',
        usageReason: 'Reason',
        usageOtherReason: 'Other',
        replacements: 'Replacements',
        partEntry: 'Part entry',
        goToPart: 'Go to part',
        fittingMachines: 'Matching machines',
    },
    costCenter: {
        costCenter: 'Cost center',
    },
    equipmentTypes: {
        equipment: 'Equipment',
        newEquipmentType: 'New equipment type',
        fittingParts: 'Fitting parts',
        goToParts: 'Go to part',
    },
    machinesAndToolsDefinitions: {
        machinesAndToolsDefinitions: 'Machines and tools definitions',
    },
    flows: {
        flow: 'Flow',
        states: 'States',
        transitions: 'Transitions',
        state: 'State',
        default: 'Default',
        warning: 'Warning',
        problem: 'Problem',
        fixing: 'Fixing',
        finished: 'Finished',
    },
    parameters: {
        categoryParameter: 'Category parameter',
        equipmentTypeParameter: 'Equipment type parameter',
    },
    staff: {
        staff: 'Staff',
        editUserAccess: 'Edit user access',
        permissionsUpdated: 'Permissions updated',
        passwordUpdated: 'Password updated',
        codeUpdated: 'Code updated',
        changePasswordAndCode: 'Change password and code',
        goToLicenses: 'Go to licenses',
        editAccess: 'Edit access',
        editUser: 'Edit user',
        addUser: 'Add new user',
        nameAndLastname: '@:common.USER_NAME_LABEL',
        accountStatus: 'Account status',
        phoneNumber: 'Phone number',
        department: 'Department',
        passwordChange: 'Password change',
        codeChange: 'Code change',
        newPassword: 'New password',
        confirmNewPassword: 'Confirm new password',
        changePassword: 'Change password',
        newCode: 'New code',
        confirmNewCode: 'Confirm new code',
        changeCode: 'Change code',
        addEntry: 'Add entry',
        editEntry: 'Edit entry',
        editLicense: 'Edit license',
        addLicense: 'Add license',
        licenseNumber: 'License number',
        prefferedLocale: 'Preffered locale',
        oldPassword: 'Old password',
        newPasswordConfirmation: 'Confirm new password',
        reading: 'Displaying',
        creating: 'Creating',
        updating: 'Updating',
        deleting: 'Deleting',
        importScheduleFile: 'Import a schedule from a file',
        importSchedule: {
            errors: {
                user_not_found: 'User not found [{user}]',
                user_found_many: '{count} users found [{user}]',
                event_collision: 'Collision of events',
                hour_cell_parse: 'Cell parsing error',
            },
        },
        oldCode: 'Old Code',
        newCodeConfirmation: 'New code confirmation',
        setAccessBasedOnProfile: 'Grant access based on templete',
        selectAccessMergeType: 'Choose how to combine accesses',
        noAccessesInProfileMessage:
            'The selected profile has no permissions. Do you want to overwrite anyway?',
    },
    breadCrumb: {
        configuration: 'Configuration',
        locations: 'Locations',
        home: 'Home',
        machines: 'Machines',
        tools: 'Tools',
        issues: 'Issues',
        notes: 'Notes',
        maintenance: 'Maintenance',
        parts: 'Parts',
        warehouse: 'Warehouse',
        dictionary: 'Dictionary',
        categories: 'Categories',
        parameters: 'Parameters',
        costCenter: 'Cost center',
        flows: 'Flows',
        states: 'States',
        transitions: 'Transitions',
        shiftSchemas: 'Shifts schemas',
        shifts: 'Shifts',
        definitionsOfMachinesAndToolsTypes:
            'Machines and tools types definitions',
        add: 'Add',
        edit: 'Edit',
        staff: 'Staff',
        licenses: 'Licenses',
        entries: 'Entries',
        companiesDatabase: 'Companies database',
        companyManagement: 'Company management',
        companyData: 'Company data',
        supportedLanguages: 'Supported languages',
        en: 'English',
        pl: 'Polish',
        es: 'Spanish',
        de: 'German',
        defaultLanguage: 'Default language',
        notifications: 'Notifications',
        notificationsManagement: 'Notifications management',
        myProfile: 'My profile',
    },
    attributeTypes: {
        text: 'Text',
        note: 'Note',
        integer: 'Integer',
        decimal: 'Decimal',
        date: 'Date',
        time: 'Time',
        dateTime: 'Date and time',
        color: 'Color',
        icon: 'Icon',
        boolean: 'Yes/No',
    },
    costCalculator: {
        costCalculator: 'Cost calculator',
        waitTime: 'Wait time',
        serviceTime: 'Service time',
        suspendTime: 'Suspend time',
        totalTime: 'Total time',
        estimatedCost: 'Estimated cost',
        calculate: 'Calculate',
        withoutParts: 'Without parts',
        timeOfReportingIssue: 'Time of reporting issue',
        timeOfServiceStart: 'Time of service start',
        timeOfReportingEnd: 'Time of service end',
        days: 'Days',
        hours: 'Hours',
        minutes: 'Minutes',
        enterNewTime: 'Enter new time',
        fromIssueReportToServiceStart:
            'Time from issue report to service start',
        fromServiceStartToServiceEnd: 'Time from service start to service end',
        workTime: 'Work time',
        includeAwaitingTime: 'Include awaiting time',
    },
    dashboard: {
        components: {
            myIssues: {
                title: 'My issues',
                assignedToMe: 'Assigned to me',
                assignedToGroup: 'Assigned to my group',
                tookByMe: 'Taken by me',
                takeIssueBtn: 'Take',
                arriveIssueBtn: 'I arrived',
                finishIssueBtn: 'Finish',
                history: 'History',
                myResponsible: "I'm responsible for",
            },
        },
    },
    synchronization: {
        enabled: 'Enabled',
        hasHeaders: 'Has headers',
        leaveFile: 'Leave file',
        host: 'Host',
        port: 'Port',
        protocol: 'Protocol',
        username: 'Username',
        password: 'Password',
        root: 'Root',
        encoding: 'Encoding',
        separator: 'Separator',
        externalSystemId: 'External system ID',
        cronExpression: 'Cron expression',
        appendFullStock: 'Append full stock',
        includeHeaders: 'Include headers',
        withTrashed: 'With removed data',
        filePattern: 'File pattern',
    },
    processes: {
        created_at: 'Created at',
        started_at: 'Started at',
        updated_at: 'Updated at',
        finished_at: 'Finished at',
        attempts: 'Attempts',
        queue: 'Queue',
        job_id: 'Job id',
        job_uuid: 'Job uuid',
        progress_max: 'Progress max',
        progress_now: 'Progress now',
        outputMessage: 'Output message',
        status: {
            queued: 'queued',
            executing: 'executing',
            finished: 'finished',
            failed: 'failed',
            retrying: 'retrying',
            undefined: 'undefined',
        },
    },
    weekDays: {
        mo: 'Monday',
        tu: 'Tuesday',
        we: 'Wednesday',
        th: 'Thursday',
        fr: 'Friday',
        sa: 'Saturday',
        su: 'Sunday',
    },
    reports: {
        reports: 'Reports',
        dateFrom: 'Start date',
        dateTo: 'End date',
        types: {
            operation_sheet: 'Operating sheet',
            issue_summary: 'Issues summary',
            grouped_summary: 'Summary report',
            storage_operations: 'Warehouse operations',
            part_quantity_export: 'Parts quantity',
        },
        reportFor: 'Report for',
        includeQuantityLeft0: 'Include parts with null quantity',
    },
    logs: {
        issues: {
            escalation: 'Escalations ({minutes} min) - notification sent',
        },
        issueEmployee: {
            assignedAt: 'Employee przypisany:',
            receivedAt: 'Employee read at:',
            tookAt: 'Employee took at',
            finishedAt: 'Employee finished at',
            deletedAt: 'Employee removed from this issue at',
        },
    },
    units: {
        no: 'Piece',
        st: 'Set',
    },
    rrule: {
        frequency: 'Periodic',
        dtstart: 'Start date',
        tzid: 'Timezone',
        until: 'Until',
        count: 'Count',
        interval: 'Interval',
        wkst: 'Start day',
        byweekday: 'By weekday',
        bymonth: 'By month',
        yearly: 'Yearly',
        monthly: 'Monthly',
        weekly: 'Weekly',
        daily: 'Daily',
        hourly: 'Hourly',
        minutely: 'Minutely',
        secondly: 'Secondly',
        infinitePeriodicityMessage:
            'Periodicity is infinite, due to performance, only 500 rows are displayed',
    },
    months: {
        jan: 'January',
        feb: 'February',
        mar: 'March',
        apr: 'April',
        may: 'May',
        jun: 'June',
        jul: 'July',
        aug: 'August',
        sep: 'September',
        oct: 'October',
        nov: 'November',
        dec: 'December',
    },
    charts: {
        charts: 'Charts',
        count: 'Number of issues',
        total: 'Total issues time (from report to finish)',
        serw: 'Total repair time (Ttotal - Twait)',
        mttr1: 'Mean time from report to finish',
        mttr2: 'Mean time from take to finish',
        mtbf: 'Mean time between failures',
        mttf: 'Mean time to failure',
    },
    accessMergeValues: {
        sum: 'Sum',
        product: 'Product',
        overwrite: 'Overwrite',
    },
    tpm: {
        history: 'History',
        standardObstacle: 'Standard obstacle',
        customObstacle: 'Custom obstacle',
        bhp: 'Health and Safety',
        returnToMainPage: 'Return to main page',
        bhpMessage:
            'If you see any safety hazards, please report them immediately to your direct supervisor and use the reporting form located below the notice board.',
        ok: 'Ok',
        send: 'Send',
        description: 'Description',
        title: 'Title',
        realization: 'Realization',
        answer: 'Answer',
        pendingSurveys: 'Pending surveys',
        surveys: 'Surveys',
        systemSurvey: 'System survey',
        addPage: 'Add page',
        createSurvey: 'Create survey',
        addSection: 'Add section',
        addQuestion: 'Add question',
        questionContent: 'Question content',
        answerOption: 'Answer option',
        addQuestionAnswer: 'Add answer option',
        surveyName: 'Survey name',
        sectionName: 'Section name',
        noSurveyAnswers: 'No answers',
        removeSection: 'Remove section',
        published: 'Published',
        unpublished: 'Unpublished',
        pendingPublication: 'Changes pending publication',
        removeQuestion: 'Remove question',
        removeAnswer: 'Remove answer option',
        publish: 'Publish',
        unpublish: 'Unpublish',
        previewResults: 'Preview results',
        supervisior: 'Supervisor',
        surveyResults: 'Survey results',
        surveysEvents: 'Events configuration - surveys',
        operatedBy: 'Operated by',
        confirmReadInformations: 'I have read the information',
        noticeContent: 'Notice content',
        notice: 'Notice',
        surveyEventName: 'Event name',
        survey: 'Survey',
        newIssue: 'New report',
        surveyEventConfigurationAlreadyExists:
            'Such configuration already exists',
        lastComment: 'Last comment by responsible person',
        surveyNotConfigured: 'Survey not configured',
        fillSurvey: 'Complete survey',
        singleSurveyEntries: 'single results',
        groupedSurveyEntries: 'Grouped results',
        publicationId: 'Publication ID',
        publicationDate: 'Date of publication',
        versionId: 'Version ID',
        answersCount: 'Number of responses',
        answers: 'Answers',
        withoutSupervisor: 'Without supervisor',
        defaultSupervisor: 'Default Supervisor',
        flowStateFlags: 'Status flags',
        qrActionsSettings: 'QR code actions settings.',
        loginRequired: 'Requires login',
        questionContext: 'Question context',
        currentSurveyVersionPreview:
            'Preview of the current version of the survey',
        surveyDescription: 'Survey description',
        sectionDescription: 'Section description',
        instructions: 'Instructions',
        instruction: 'Instruction',
        instructionRevisions: 'Revisions',
        instructionRevision: 'Revision',
        checklists: 'Checklists',
        checklist: 'Checklist',
        checklistItem: 'List item',
        manageChecklistFields: 'Manage list items',
        checklistItemDisplayOptions: 'Displayed items',
        revisionAutoRejectedInfo: '[System] Rejected - new revision created',
    },
    checklists: {
        itemBasic: 'Basic element',
        itemSeparator: 'Separator',
        itemSection: 'Section',
        publish: 'Publish',
        previewCurrentVersion: 'Preview of the current version',
    },
};
